import React from "react";

// Fixed 4px gold progress bar at the very top of the viewport.
export default function ProgressBar({ progress }) {
  return (
    <div
      className="fixed top-0 left-0 z-50 w-full"
      style={{ height: 4, backgroundColor: "transparent", pointerEvents: "none" }}
      data-testid="progress-bar-track"
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Assessment progress"
    >
      <div
        data-testid="progress-bar-fill"
        style={{
          height: "100%",
          width: `${progress}%`,
          backgroundColor: "var(--rtd-gold)",
          transition: "width 400ms cubic-bezier(0.22, 1, 0.36, 1)",
          boxShadow: progress > 0 ? "0 0 12px rgba(232,160,32,0.5)" : "none",
        }}
      />
    </div>
  );
}
